import React from "react";
import { Icon } from "semantic-ui-react";

export function getIcon(ext: string, isEditable: boolean, childRecs: any) {
    if (isEditable && ext === "")
        return <Icon name="file outline" size="large" className="editable-file" />

    switch (ext.toUpperCase()) {
        case "PPTX" : 
        case "PPTM" : 
        case "PPT" : 
            return <Icon name='file powerpoint outline' size="large" className="powerpoint" style={{ marginLeft: childRecs === 0 ? "28px" : "0px" }} />
        case "DOCX" : 
        case "DOCM" : 
        case "DOC" : 
            return <Icon name='file word outline' size="large" className="word" style={{ marginLeft: childRecs === 0 ? "28px" : "0px" }} />
        case "XLSX" : 
        case "XLSM" : 
        case "XLS" : 
            return <Icon name='file excel outline' size="large" className="excel" style={{ marginLeft: childRecs === 0 ? "28px" : "0px" }} />
        case "PDF" : 
            return <Icon name='file pdf outline' size="large" className="pdf" style={{ marginLeft: childRecs === 0 ? "28px" : "0px" }} />
        case "JPG" : 
            return <Icon name='file image outline' size="large" className="img-files" style={{ marginLeft: childRecs === 0 ? "28px" : "0px" }} />
        case "PNG" :
            return <Icon name='file image outline' size="large" className="img-files" style={{ marginLeft: childRecs === 0 ? "28px" : "0px" }} />
        case "EML" : 
            return <Icon name='envelope outline' size="large" className="eml-files" style={{ marginLeft: childRecs === 0 ? "28px" : "0px" }} />
        case "MSG" : 
            return <Icon name='envelope outline' size="large" className="eml-files" style={{ marginLeft: childRecs === 0 ? "28px" : "0px" }} />
        case "":
            return <Icon name='folder outline' size="large" className="folder-icon" style={{ marginLeft: childRecs === 0 ? "28px" : "0px" }} />
        default: return <Icon name="file outline" size="large" style={{ marginLeft: childRecs === 0 ? "28px" : "0px" }} />
    }
}